import 'regenerator-runtime'
import './index.css'
import {EventBus, EventTypes} from './consts/const-event-types'

/*
To add new components, import them here and add them to the 'components'-array below.
Add an appropriate selectorName for use in DOM (fx: <div data-component="header"></div>):
*/
import App from './components/app'
import Header from './components/header/header'
import ChartComponent from './components/chart-component/chart-component'
import ChartComponentExample from './components/chart-component/chart-component-example'
import ChartJSComponent from './components/chartjs-component/chartjs-component'
import ChartJSStackedComponent from './components/chartjs-component/chartjs-stacked-component'
import ChartJSLineComparisonComponent from './components/chartjs-component/chartjs-line-comparison-component'
import ReadMoreComponent from './components/readmore-component/readmore-component'
import ChartJSLineComponent from './components/chartjs-component/chartjs-line-component'
import ChartJSStackedDelComponent from './components/chartjs-component/chartjs-stacked-del-component'
import FilterComponent from './components/filter-component/filter-component'
import SalaryLegendComponent from './components/salary-legend-component/salary-legend-component'
import JumpToComponent from './components/jump-to-component/jump-to-component'


const components = [
  {Class: App, selectorName: 'app'},
  {Class: Header, selectorName: 'header'},
  {Class: ChartComponent, selectorName: 'chart-component'},
  {Class: ChartComponentExample, selectorName: 'chart-component-example'},
  {Class: ChartJSComponent, selectorName: 'chartjs-component'},
  {Class: ChartJSStackedComponent, selectorName: 'chartjs-stacked-component'},
  {Class: ChartJSLineComparisonComponent, selectorName: 'chartjs-line-comparison-component'},
  {Class: ReadMoreComponent, selectorName: 'readmore-component'},
  {Class: ChartJSLineComponent, selectorName: 'chartjs-line-component'},
  {Class: ChartJSStackedDelComponent, selectorName: 'chartjs-stacked-del-component'},
  {Class: FilterComponent, selectorName: 'filter-component'},
  {Class: SalaryLegendComponent, selectorName: 'salary-legend-component'},
  {Class: JumpToComponent, selectorName: 'jump-to-component'},
]

/*
* ComponentInstantiator traverses the DOM-tree and looks for [data-component='] attributes.
*/
class ComponentInstantiator {
  constructor() {
    this.createComponents()
    this.dispatchReady()
    return this
  }

  createComponents() {
    this.componentsInstantiated = {}

    components.map(component => {
      const nodes = []
      // select all DOM-nodes with the data-component attribute:
      const nodeItems = [...document.querySelectorAll("[data-component='" + component.selectorName + "']")]

      nodeItems.map(nodeItem => {
        // instantiate component with nodeItem as param:
        nodes.push(new component.Class(nodeItem))
      })

      // add to componentsList object:
      if (nodes.length) this.componentsInstantiated[component.selectorName] = nodes
    })
  }

  dispatchReady() {
    const event = new CustomEvent(EventTypes.ALL_COMPONENTS_READY)
    EventBus.dispatchEvent(event)
  }

  getComponents(selectorName) {
    return selectorName ? this.componentsInstantiated[selectorName] : this.componentsInstantiated
  }
}

/* Make your App accessible via window.App */
window.App = new ComponentInstantiator()

/* Access components list */
// console.log('components on this page', window.App.getComponents())
